import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

export default function FormBehavior(props) {
  const [value, setValue] = React.useState('');
  const options=[
      'Never',
      'Less than once a week',
      'Once a week',
      'Less than once a day but several times a week',
      'At least once a day',
      'Several times a day'
  ]
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <RadioGroup size='small' aria-label="freq" name="freq" value={value} onChange={handleChange}>
      {options.map((option, idx)=>{
        return(<FormControlLabel size='small' key={idx} value={idx} control={<Radio size='small'/>} label={option} />)
      })}
      </RadioGroup>
    </FormControl>
  );
}
